import { Text, VStack } from '@chakra-ui/react';
import { NoSearchIcon } from 'assets/icons/v2';

type Props = {
  query: string;
};

export const NoSearchResult = ({ query }: Props): JSX.Element => {
  return (
    <VStack align="center" justify="center" gap="10px" py="50px">
      <NoSearchIcon boxSize="28px" color="icon.tertiary" />
      <Text textStyle="body.m.regular" color="text.tertiary">
        Leider wurden keine Ergebnisse für &quot;{query}&quot; gefunden.
      </Text>
    </VStack>
  );
};
